import React from 'react'

import flowerFooter from 'src/assets/images/schedule_call_flower_footer.webp'

export const ScheduleCallFooter = () => {
  return (
    <div className="footer">
      <img src={flowerFooter} alt="flower-footer" loading="lazy" />
    </div>
  )
}
